<template>
  <div>
    <CCol sm="12">
      <CRow></CRow>
    </CCol>
    <CCard>
      <CCol sm="12">
        <CRow class="p-3">
          <h5>
            Learning Center Information
            <strong class="text-danger">
              (* is compulsary for you to fill up and others are
              optional)</strong
            >
          </h5>
        </CRow>
        <CRow>
          <CCol sm="2">Learning Center ID</CCol>
          <CCol sm="3"><CInput type="text" /></CCol>
        </CRow>
        <hr />

        <h5>Student Information</h5>
        <CRow>
          <CCol sm="2">Full Name</CCol>
          <CCol sm="10"><CInput type="text" /></CCol>

          <CCol sm="2">IC/Birth Certificate</CCol>
          <CCol sm="4"><CInput type="text" /></CCol>

          <CCol sm="2">Age</CCol>
          <CCol sm="4"><CInput type="text" /></CCol>

          <CCol sm="2">Date of Birth</CCol>
          <CCol sm="4"><CInput type="text" /></CCol>

          <CCol sm="2">Gender</CCol>
          <CCol sm="4"
            ><input type="radio" />Female
            <input type="radio" class="ml-3" />Male</CCol
          >

          <CCol sm="2">Main Contact</CCol>
          <CCol sm="4"><CInput type="text" /></CCol>

          <CCol sm="2">Email</CCol>
          <CCol sm="4"><CInput type="text" /></CCol>

          <CCol sm="2">Grade</CCol>
          <CCol sm="4"><CInput type="text" /></CCol>

          <CCol sm="2">School Name</CCol>
          <CCol sm="4"><CInput type="text" /></CCol>

          <CCol sm="2">Student Payment Rate Type</CCol>
          <CCol sm="4"><CInput type="text" /></CCol>

          <!-- <CCol sm="2">Facebook</CCol>
          <CCol sm="4"><CInput type="text" /></CCol>

          <CCol sm="2">Allergy Food</CCol>
          <CCol sm="10"><CInput type="text" /></CCol> -->
        </CRow>

        <hr />

        <h5>Parent Information</h5>
        <CRow>
          <CCol sm="2">Parents Name </CCol>
          <CCol sm="10"><CInput type="text" /></CCol>

          <CCol sm="2">Email</CCol>
          <CCol sm="4"><CInput type="text" /></CCol>

          <CCol sm="2">Home Phone Number</CCol>
          <CCol sm="4"><CInput type="text" /></CCol>

          <CCol sm="2">H/P (Father)</CCol>
          <CCol sm="4"><CInput type="text" /></CCol>

          <CCol sm="2">H/P (Mother)</CCol>
          <CCol sm="4"><CInput type="text" /></CCol>

          <CCol sm="2">Occupation</CCol>
          <CCol sm="4"><CInput type="text" /></CCol>

          <CCol sm="2">Company/Department</CCol>
          <CCol sm="4"><CInput type="text" /></CCol>

          <CCol sm="2">Address </CCol>
          <CCol sm="10"><CInput type="text" /></CCol>

          <CCol sm="2">Zip Code</CCol>
          <CCol sm="4"><CInput type="text" /></CCol>

          <CCol sm="2">State</CCol>
          <CCol sm="4"><CInput type="text" /></CCol>
        </CRow>
        <hr />

        <!-- <h5>Subject Information</h5>
        <CRow>
          <CCol sm="2">Others</CCol>
          <CCol sm="10">
            <input
              type="checkbox"
              name="package_name"
              value="others-taska"
              class="ml-3"
            />
            TASKA
            <input
              type="checkbox"
              name="package_name"
              value="others-transit"
              class="ml-3"
            />
            TRANSIT
          </CCol>
          <br /><br />

          <CCol sm="2">Bahasa</CCol>
          <CCol sm="10">
            <input
              type="checkbox"
              name="package_name"
              value="mandarin"
              class="ml-3"
            />
            MANDARIN
            <input
              type="checkbox"
              name="package_name"
              value="japanese"
              class="ml-3"
            />
            JAPANESE
            <input
              type="checkbox"
              name="package_name"
              value="korean"
              class="ml-3"
            />
            KOREAN
            <input
              type="checkbox"
              name="package_name"
              value="english"
              class="ml-3"
            />
            ENGLISH
            <input
              type="checkbox"
              name="package_name"
              value="french"
              class="ml-3"
            />
            FRENCH
            <input
              type="checkbox"
              name="package_name"
              value="italian"
              class="ml-3"
            />
            ITALIAN
            <input
              type="checkbox"
              name="package_name"
              value="arabic"
              class="ml-3"
            />
            ARABIC
          </CCol>
          <br /><br />

          <CCol sm="2">Standard 1-6</CCol>
          <CCol sm="10">
            <input
              type="checkbox"
              name="package_name"
              value="standard-bahasamalaysiapemahaman"
              class="ml-3"
            />
            BAHASA MALAYSIA / PEMAHAMAN
            <input
              type="checkbox"
              name="package_name"
              value="standard-bahasamalaysiapenulisan"
              class="ml-3"
            />
            BAHASA MALAYSIA / PENULISAN
            <input
              type="checkbox"
              name="package_name"
              value="standard-bahasainggeris"
              class="ml-3"
            />
            BAHASA INGGERIS
            <input
              type="checkbox"
              name="package_name"
              value="standard-matematik"
              class="ml-3"
            />
            MATEMATIK
            <input
              type="checkbox"
              name="package_name"
              value="standard-sains"
              class="ml-3"
            />
            SAINS
          </CCol>
             <br /><br />

          <CCol sm="2">Form 1-3</CCol>
          <CCol sm="10">
            <input
              type="checkbox"
              name="package_name"
              value="form-bahasamalaysia"
              class="ml-3"
            />
            BAHASA MALAYSIA
            <input
              type="checkbox"
              name="package_name"
              value="form-bahasainggeris"
              class="ml-3"
            />
            BAHASA INGGERIS
            <input
              type="checkbox"
              name="package_name"
              value="form-matematik"
              class="ml-3"
            />
            MATEMATIK
            <input
              type="checkbox"
              name="package_name"
              value="form-sains"
              class="ml-3"
            />
            SAINS
            <input
              type="checkbox"
              name="package_name"
              value="form-sejarah"
              class="ml-3"
            />
            SEJARAH
            <input
              type="checkbox"
              name="package_name"
              value="form-geografi"
              class="ml-3"
            />
            GEOGRAFI
          </CCol>
   <br /><br />
          <CCol sm="2">Form 4-6</CCol>
          <CCol sm="10">
            <input
              type="checkbox"
              name="package_name"
              value="form-4-bahasamalaysia"
              class="ml-3"
            />
            BAHASA MALAYSIA
            <input
              type="checkbox"
              name="package_name"
              value="form-4-bahasainggeris"
              class="ml-3"
            />
            BAHASA INGGERIS
            <input
              type="checkbox"
              name="package_name"
              value="form-4-mathmodern"
              class="ml-3"
            />
            MATEMATIK MODEN
            <input type="checkbox" name="package_name" value="form-4-addmath" class="ml-3"/>
            MATEMATIK TAMBAHAN
            <input type="checkbox" name="package_name" value="form-4-sains" class="ml-3" />
            SAINS
            <input type="checkbox" name="package_name" value="form-4-sejarah" class="ml-3"/>
            SEJARAH
            <input type="checkbox" name="package_name" value="form-4-akaun" class="ml-3"/>
            PRINSIP AKAUN
          </CCol>
          <br /><br />

          <CCol sm="2">Others Subject</CCol>
          <CCol sm="10">
             <input type="checkbox" name="package_name" value="form-4-akaun" class="ml-3"/> OTHERS SUBJECT
          </CCol>
        </CRow> -->

          <!-- <h5>Remarks</h5> -->
        <!-- <hr /> -->
        <CRow>
             <CCol sm="2"></CCol>
          <CCol sm="10">
             <!-- <CTextarea type="textarea" rows="5" /> -->
               <!-- <input type="checkbox" id="checkbox-agreement" /> I agree with all the terms and conditions set by learning center -->
               <br /><br />
                <input type="submit" class="btn btn-success float-right" value="SAVE FORM"/>
                 <br /><br />
          </CCol>
        </CRow>

      </CCol>
    </CCard>
  </div>
</template>


<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import FullCalendar from "vue-full-calendar";
import "fullcalendar/dist/fullcalendar.css";
import backgroundUrl from "../assets/img/bgCard.png";
import VCalendar from "v-calendar";
import VueCal from "vue-cal";
import "vue-cal/dist/vuecal.css";

import _ from "lodash";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { CChartBar } from "@coreui/vue-chartjs";
import VueEllipseProgress from "vue-ellipse-progress";

//import "@fullcalendar/core/vdom"; // solves problem with Vite]

import { Calendar } from "vue-sweet-calendar";
import "vue-sweet-calendar/dist/SweetCalendar.css";
import "material-design-icons-iconfont/dist/material-design-icons.css";
export default {
  name: "Tables",
  components: {
    PulseLoader,
    CChartBar,
    Calendar,
    VCalendar,
    VueCal,
  },
  data() {
    return {
      backgroundUrl,
    };
  },
  mounted() {},
  methods: {
      async SubmitStudent() {
      const formData = new FormData();

      formData.append("TuitionSubjectId", this.subId);
      formData.append("ScheduleDateTime", this.ScheduleDateTime);
      formData.append("ScheduleDateTimeEnd", this.ScheduleDateTimeEnd);

      formData.append("TeacherId", this.selectedTeachers.Id);
      formData.append("ThemeColor", this.selectedColor.Name);

      formData.append("interval", this.interval);

      return this.$API
        .post(this.$InsertRegistrationStudent, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.Busy = false;
            this.$dialog.alert("Success Save Schedule").then(function () {});
            this.ScheduleModal = false;
            this.RefreshData();
          } else {
            this.Busy = false;
            this.$dialog.alert("Error to save ").then(function () {});
          }
        })
        .catch((error) => {
          this.Busy = false;
          this.Loading = false;
          this.Error = true;
          this.Message = error.response.data.message;
        });
    },



  },
};
</script>
